var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 0